import aws from 'aws-sdk';
import uuid from 'uuid';
import client from '../../client';

export default (dispatch, file, updateUploadProgressAction) => {
  const params = {
    Key: `${uuid.v4()}`,
    Body: file,
    ContentType: file.type,
  };

  return client
    .get(`auth/upload-token`)
    .then(response =>
      response.json().then(json => {
        params.Bucket = json.Bucket;
        aws.config.correctClockSkew = true;
        aws.config.update({ region: json.Region });
        aws.config.apiVersions = {
          s3: '2006-03-01',
          // other service API versions
        };
        aws.config.credentials = new aws.CognitoIdentityCredentials({
          IdentityPoolId: json.IdentityPoolId,
          IdentityId: json.IdentityId,
          Logins: {
            'cognito-identity.amazonaws.com': json.Token,
          },
        });

        return new aws.S3();
      })
    )
    .then(s3Client =>
      s3Client
        .upload(params)
        .on('httpUploadProgress', evt => {
          dispatch(updateUploadProgressAction(evt.loaded, evt.total));
        })
        .promise()
    );
};



// WEBPACK FOOTER //
// ./src/common/utils/uploadVideoToS3.js